<template>
    <div class="footer">
        <p @click="handleClick">粤ICP备2025487643号-1</p>
    </div>
</template>


<script setup>
import { ref } from 'vue'

const handleClick = () => {
    window.open('https://beian.miit.gov.cn/', '_blank')
}

</script>


<style scoped lang="scss">
.footer {
    width: 100vw;
    height: 30px;
    text-align: center;
    background-color: #999999;
    color: #ffffff;

    p {
        cursor: pointer;
        line-height: 30px;
        padding: 0;
        margin: 0;
        font-size: 14px;
    }
}
</style>